<template>
    <div class="" v-if="aItems.length > 0">
        <h2>学生评价</h2>
        <div>
            <div class="item" v-for="(item, index) in aItems" :key="index">
                <div class="x-relative">
                    <div class="x-avatar">
                        <img  alt="小鸥游学学员头像"  :src="myUtils.getUrlPic(item.avatar.data,'thumbnail')" />
                    </div>
                    <div class="x-absolute detail">
                        <p class="name">{{ item.name }}</p>
                        <p class="desc">{{ item.desc}}</p>
                    </div>
                </div>
                <div class="comment-box x-relative">
                    <div class="comment-left x-absolute">
                        <img  alt="左引号图标"  src="/assets/img/comment_left.svg" />
                    </div>
                    <div class="comment">
                        {{  item.comment }}
                    </div>
                    <div class="comment-right x-absolute">
                        <img  alt="右引号图标"  class="comment-right-pic" src="/assets/img/comment_right.svg" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>



<script setup>

const props = defineProps({
    data: Object
})
const aItems = ref([]);
aItems.value = props.data.data.attributes.comments || [];

</script>

<style scoped>
.x-avatar {
    width: 56px;
    height: 56px;
}

.detail {
    left: 80px;
    top: 0px;
}

.name {
    font-size: 18px;
    font-weight: 700;
    color: #2B2F33;
}

.desc {
    font-size: 16px;
    font-weight: 500;
    color: #787D83;
}

.item {
    border: 1px solid #F4F5F6;
    border-radius: 24px;
    padding: 24px;
    margin: 24px 0;
}

h2 {
    border-top: 1px solid #eee;
    padding-top: 32px;
    margin-top: 32px;
    color: var(--text-text-primary, #2B2F33);
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    margin-top: 24px;
}

.comment-left {
    left: 0;
    top: 0;
    height: 100%;
    width: 15px;
    padding: 0 8px;

}

.comment-box {
    margin-top: 24px;
}

.comment {
    margin-left: 40px;
    margin-right: 40px;
}

.comment-right {
    right: 0px;
    top: 0px;
    width: 15px;
    padding: 0 8px;
    height: 100%;
}

.comment-right-pic {
    position: absolute;
    bottom: 0;
    right: 0;
}</style>